<template>
    <div
        class="date-time"
        :class="{
            'date-time_mobile': isMobile,
        }"
    >
        <div class="date-time__wrap">
            <div class="date-time__combo">
                <div class="date-time__combo-item">
                    <day-select
                            :value="dateStart"
                            :show-week-day="false"
                            :short-month="true"
                            :small="true"
                            :show-year="false"
                            @input="changeDateStart($event)"
                    ></day-select>
                </div>
                <div class="date-time__combo-item">
                    <v-menu
                            v-model="menuStart"
                            offset-y
                            bottom
                            :close-on-content-click="false"
                    >
                        <template v-slot:activator="{on}">
                            <div v-on="on">
                                <v-text-field
                                        :label="$t('msg.start')"
                                        :value="getTimeStart"
                                        outlined
                                        hide-details
                                        :dense="!isMobile"
                                        readonly
                                        class="date-time__hours"
                                        clearable
                                        @click:clear="deleteTimeStart()"
                                        :error="errorMessages.length > 0"
                                ></v-text-field>
                            </div>
                        </template>
                        <v-time-picker
                                v-if="menuStart"
                                :value="getTimeStart"
                                format="24hr"
                                :allowed-minutes="v => v%5 === 0"
                                no-title
                                @click:minute="menuStart = false"
                                @input="changeTimeStart($event)"
                                @change="changeStart()"
                        ></v-time-picker>
                    </v-menu>
                </div>
                <div v-if="presetStart.length > 0" class="date-time__combo-item">
                    <div
                            v-for="item in presetStart"
                            class="date-time__preset-item"
                            @click="changeTimeStart(item)"
                    >{{ item }}</div>
                </div>
            </div>
            <div class="date-time__space">
                <div class="date-time__hyphen"></div>
            </div>
            <div class="date-time__combo">
                <div class="date-time__combo-item">
                    <day-select
                            :value="dateEnd"
                            :show-week-day="false"
                            :short-month="true"
                            :small="true"
                            :show-year="false"
                            @input="changeDateEnd($event)"
                    ></day-select>
                </div>
                <div class="date-time__combo-item">
                    <v-menu
                            v-model="menuEnd"
                            offset-y
                            bottom
                            :close-on-content-click="false"
                    >
                        <template v-slot:activator="{on}">
                            <div v-on="on">
                                <v-text-field
                                        :label="$t('msg.end')"
                                        :value="getTimeEnd"
                                        outlined
                                        hide-details
                                        :dense="!isMobile"
                                        readonly
                                        class="date-time__hours"
                                        clearable
                                        @click:clear="deleteTimeEnd()"
                                        :error="errorMessages.length > 0"
                                ></v-text-field>
                            </div>
                        </template>
                        <v-time-picker
                                v-if="menuEnd"
                                :value="getTimeEnd"
                                format="24hr"
                                :allowed-minutes="v => v%5 === 0"
                                no-title
                                @click:minute="menuEnd = false"
                                @input="changeTimeEnd($event)"
                        ></v-time-picker>
                    </v-menu>
                </div>
                <div v-if="presetEnd.length > 0" class="date-time__combo-item">
                    <div
                            v-for="item in presetEnd"
                            class="date-time__preset-item"
                            @click="changeTimeEnd(item)"
                    >{{ item }}</div>
                </div>
            </div>
        </div>
        <div
                v-if="errorMessages.length > 0"
                class="date-time__error"
        >{{ errorMessages[0] }}</div>
    </div>
</template>

<script>
    import DaySelect from "./DaySelect";
    import {format, addMinutes} from "date-fns";

    export default {
        components: {DaySelect},
        props: {
            day: {type: Date, default: null},
            start: {type: Date, default: null},
            end: {type: Date, default: null},
            errorMessages: {type: Array, default: () => []},
            presetStart: {type: Array, default: () => []},
            presetEnd: {type: Array, default: () => []},
            autoSetEnd: {type: Boolean, default: false}
        },
        data() {
            return {
                localStart: this.start,
                localEnd: this.end,
                dateStart: !!this.start ? this.start : this.day,
                dateEnd: !!this.end ? this.end : this.day,
                menuStart: false,
                menuEnd: false,
                recountLocalStart: 0,
                recountLocalEnd: 0,
                value: { // for validator
                    start: this.start,
                    end: this.end
                }
            }
        },
        computed: {
            getTimeStart() {
                if (this.localStart == null) return null;
                this.recountLocalStart;
                return format(this.localStart, 'HH:mm');
            },
            getTimeEnd() {
                if (this.localEnd == null) return null;
                this.recountLocalEnd;
                return format(this.localEnd, 'HH:mm');
            }
        },
        watch: {
            localStart: {
                handler(v) {
                    this.$emit('update:start', v);
                    this.value.start = v;
                },
                deep: true
            },
            localEnd: {
                handler(v) {
                    this.$emit('update:end', v);
                    this.value.end = v;
                },
                deep: true
            },
            start(v) {
                this.localStart = v;
                this.value.start = v;
                this.setDayStart(this.localStart);
            },
            end(v) {
                this.localEnd = v;
                this.value.end = v;
                this.setDayEnd(this.localEnd);
            },

            day: {// Было закомментировано, баг с перезаписыванием даты
                handler(v) {
                    this.dateStart = v;
                    this.dateEnd = v;
                },
                deep: true
            }
        },
        methods: {
            changeDateStart(v) {
                this.dateStart = v;

                if (this.localStart === null) return;

                this.localStart.setDate(v.getDate());
                this.localStart.setMonth(v.getMonth());
                this.localStart.setFullYear(v.getFullYear());
            },
            changeDateEnd(v) {
                this.dateEnd = v;

                if (this.localEnd === null) return;

                this.localEnd.setDate(v.getDate());
                this.localEnd.setMonth(v.getMonth());
                this.localEnd.setFullYear(v.getFullYear());
            },
            getDateFromDate(d) {
                return new Date(d.getFullYear(), d.getMonth(), d.getDate());
            },
            changeTimeStart(v) {
                if (!this.localStart) {
                    this.localStart = !!this.dateStart ? this.getDateFromDate(this.dateStart) : this.getDateFromDate(new Date());
                }
                let parts = v.split(':');
                this.localStart.setHours(parseInt(parts[0]), parseInt(parts[1]));
                this.recountLocalStart++;

                this.changeStart();
            },
            changeTimeEnd(v) {
                if (!this.localEnd) {
                    this.localEnd = !!this.dateEnd ? this.getDateFromDate(this.dateEnd) : this.getDateFromDate(new Date());
                }
                let parts = v.split(':');
                this.localEnd.setHours(parseInt(parts[0]), parseInt(parts[1]));
                this.recountLocalEnd++;
            },
            deleteTimeStart() {
                this.localStart = null;
            },
            deleteTimeEnd() {
                this.localEnd = null;
            },
            setDayStart(v) {
                if (v !== null) {
                    this.dateStart = v;
                }
            },
            setDayEnd(v) {
                if (v !== null) {
                    this.dateEnd = v;
                }
            },
            setDay(day) {
                this.dateStart = day;
                this.dateEnd = day;
            },
            changeStart() {
                if (this.autoSetEnd) {
                    if (!this.localEnd) {
                        this.localEnd = this.localStart;
                        this.localEnd = addMinutes(this.localEnd, 5)
                    }
                }
            }
        },
        created() {
            this.setDayStart(this.localStart);
            this.setDayEnd(this.localEnd);
        }
    }
</script>

<style lang="scss">
    .date-time {
        &.date-time_mobile {
            .date-time__hyphen {
                margin-top: 54px;
            }
            .date-time__preset-item {
                font-size: 16px;
                padding: 5px;
            }
            .day-select__date {
                font-size: 16px;
            }
            .day-select__btn {
                width: 30px;
                height: 30px;

                .v-icon {
                    font-size: 22px;
                }
            }
        }
        .date-time__wrap {
            display: flex;
            align-items: stretch;
        }
        .date-time__space {
            display: flex;
            align-items: flex-start;
        }
        .date-time__hyphen {
            width: 10px;
            height: 2px;
            background-color: #656565;
            margin: 46px 10px 0 10px;
        }
        .date-time__hours {
            max-width: 140px;
            margin-top: 5px !important;

            input {
                padding: 0;
                font-size: 16px !important;
                text-align: center;
            }
        }
        .date-time__combo {
            display: flex;
            flex-direction: column;
        }
        .date-time__combo-item {
            display: flex;
            justify-content: center;
        }
        .date-time__error {
            color: #ff5252;
            padding: 2px 0 0 12px;
            font-size: 12px;
        }
        .date-time__preset-item {
            margin: 1px 2px 0 2px;
            font-size: 12px;
            color: #888;
            cursor: pointer;
            user-select: none;

            &:hover {
                text-decoration: underline;
                color: #333;
            }
        }
    }
</style>